<template>
  <div>
    <div class="columns is-multiline is-mobile is-centered is-vcentered">
      <div class="column title-text-style">DRIVER PERFORMANCE</div>
      <b-field
        horizontal
        class="column"
        label="Select Date"
      >
        <b-datepicker
          v-model="selectedDate"
          placeholder="Click to select..."
          icon="calendar-today"
          trap-focus
          :max-date="maxDate"
          @input="goSeletedDay => {
                  unloadedData()
                  initOnStore()
                  updateTimeStamp = dateFormatter
                }"
        >
        </b-datepicker>
        <b-button
          class="is-primary"
          @click="goToday =>{
        selectedDate = new Date()
        initOnStore()
        }"
        >Go Today</b-button>
      </b-field>

    </div>

    <b-loading
      :is-full-page="false"
      v-model="loading"
    >
      <font-awesome-icon
        icon="fa-solid fa-sync" spin
        size="2x">
      </font-awesome-icon>
      <div style="padding-left:10px;"> Loading Data </div>
      </b-loading>
    <div
      v-if="!loading"
      class="columns is-multiline is-mobile is-centered"
    >
      <div class="column is-full">
        <CardContent
          title='Delivery Status'
          :datetime='updateTimeStamp'
        >
          <div class="columns is-vcentered is-multiline is-centered">
            <div class="column is-half">
              <Charttest
                title="t1"
                :canClick="true"
                :option="chartLateOnTime"
                :listOfDriver="getListDriverLateNotLate"
                height="500px"
              />
            </div>
            <div class="column">
              <p>Most On-time Driver</p>
              <b-table
                :sticky-header="true"
                :centered="true"
                :data="tableLate"
                :columns="tableHeader"
                :hoverable="true"
                :striped="true"
                :height="500"
              ></b-table>
              <b-table><template #footer>
                  <th class="has-text-left">Success Order</th>
                  <th>{{sumSuccessOrder}}</th>
                  <th>Order(s)</th>
                </template></b-table>
            </div>
          </div>
        </CardContent>
      </div>
      <div class="column is-full">
        <CardContent
          title='Status In Hours'
          :datetime='updateTimeStamp'
          note=""
        >
          <Charttest
            title="t2"
            :option="activeDriverChart"
          />
        </CardContent>
      </div>
      <div class="column is-full">
        <CardContent
          title='Success Order In Hours'
          :datetime='updateTimeStamp'
        >
          <Charttest
            title="t3"
            :option="stackChart"
          />
        </CardContent>
      </div>
      <!-- <div class="column is-half">
        <CardContent title='Success Order'>
          <Charttest
            title="dvP4"
            :option="chartOption"
          />
        </CardContent>
      </div>
      <div class="column is-half">
        <CardContent title='Finding Driver'>
          <Charttest
            title="dvP2"
            :option="chartOption"
          />
        </CardContent>
      </div>
      <div class="column is-half">
        <CardContent title='Derivering Order'>
          <Charttest
            title="dvP3"
            :option="chartOption"
          />
        </CardContent>
      </div>
      <div class="column is-half">
        <CardContent title='Issue'>
          <Charttest
            title="dvP7"
            :option="chartOption"
          />
        </CardContent>
      </div> -->
      <div class="column is-full">
        <CardContent
          title='Express Service Level Agreement'
          :datetime='updateTimeStamp'
        >
          <div class="columns is-vcentered is-multiline is-centered">
            <div class="column is-full">
              <ExpressSLAChart
                title="t2"
                :option="chartExpressSLA"
                height="500px"
                :list="expressSLA"
              />
            </div>
            <div class="column">
              <p>Delivery duration</p>
              <!-- <b-table
                :sticky-header="true"
                :centered="true"
                :data="expressSLATable"
                :columns="expressSLATableHeader"
                :hoverable="true"
                :striped="true"
                :height="500"
              >
                <b-table-column field="Level" centered v-slot="props">
                    <span class="tag is-success">{{ props.row.Level }}</span>
                </b-table-column>
              </b-table> -->
              <b-table
                :sticky-header="true"
                :centered="true"
                :data="expressSLATable"
                :hoverable="true"
                :striped="true"
                :height="500"
              >
                <b-table-column field="ID" label="Order ID" centered v-slot="props">
                    <span>
                        {{props.row.ID}}
                    </span>
                </b-table-column>
                <b-table-column field="DriverName" label="Driver Name" centered v-slot="props">
                    <span>
                        {{props.row.DriverName}}
                    </span>
                </b-table-column>
                <b-table-column field="Distance" label="Distance" centered v-slot="props">
                    <span>
                        {{props.row.Distance}}
                    </span>
                </b-table-column>
                <b-table-column field="OrderCreationTime" label="Purchase time" centered v-slot="props">
                    <span>
                        {{props.row.OrderCreationTime}}
                    </span>
                </b-table-column>
                <b-table-column field="SlotTimeText" label="Slot" centered v-slot="props">
                    <span>
                        {{props.row.SlotTimeText}}
                    </span>
                </b-table-column>
                <b-table-column field="Start" label="Start Time" centered v-slot="props">
                    <span>
                        {{props.row.Start}}
                    </span>
                </b-table-column>
                <b-table-column field="End" label="Success Time" centered v-slot="props">
                    <span>
                        {{props.row.End}}
                    </span>
                </b-table-column>
                <b-table-column field="Level" label="SLA" centered v-slot="props">
                    <span  :class="
                        [
                            'tag',
                            {'is-excellent': props.row.Level === 'Excellent'},
                            {'is-good': props.row.Level === 'Good'},
                            {'is-fair': props.row.Level === 'Fair'},
                            {'is-poor': props.row.Level === 'Poor'},
                            {'is-bad': props.row.Level === 'Bad'}
                        ]">
                        {{props.row.Level}}
                    </span>
                </b-table-column>
                <b-table-column field="Duration" label="Delivery Duration (minute)" centered v-slot="props">
                    <span>
                        {{props.row.Duration}}
                    </span>
                </b-table-column>
                <b-table-column field="Branch" label="Branch" centered v-slot="props">
                    <span>
                        {{props.row.Branch}}
                    </span>
                </b-table-column>
              </b-table>
              <b-table><template #footer>
                  <th class="has-text-left">Total Order</th>
                  <th>{{ expressSLAOrders.length }}</th>
                  <th>Order(s)</th>
                </template></b-table>
            </div>
          </div>
        </CardContent>
      </div>
    </div>
  </div>
</template>

<script>
import { optionLine } from '@/setting/ChartOptionLine'
import { optionPie } from '@/setting/ChartOptionPie'
import { optionPie2 } from '@/setting/ChartOptionPie2'
import { optionBar } from '@/setting/ChartOptionBar'
import { expressSLATableHeader } from '@/setting/expressSLA'
import { getBranchNameByCode } from '@/setting/branchs'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(duration)
dayjs.extend(localizedFormat)

export default {
  components: {
    Charttest: () => import('@/components/Charttest.vue'),
    CardContent: () => import('@/components/CardContent.vue'),
    ExpressSLAChart: () => import('@/components/ExpressSLAChart.vue')
  },
  mounted () {
    this.initOnStore()
    this.onUpdateEveryHour()
    this.intervalidUpdate = setInterval(() => {
      this.onUpdateEveryHour()
    }, 600000)
  },
  data () {
    return {
      maxDate: new Date(),
      minDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      ),
      selectedDate: new Date(),
      dataRange: ['AllTime', 'Daily'],
      selectedDataRange: 'Daily',
      tableHeader: [
        {
          field: 'driverName',
          label: 'Driver Name',
          centered: true
        },
        {
          field: 'delivered',
          label: 'Delivered',
          centered: true
        },
        {
          field: 'onTimeRatioDriver',
          label: '% On-Time Delivered',
          centered: true
        },
        {
          field: 'branch',
          label: 'Branch',
          centered: true
        }
      ],
      loading: true,
      daylookback: 7,
      updateTimeStamp: dayjs().format('YYYY-MM-DD HH:00:00'),
      intervalidUpdate: '',
      chartOption: optionLine,
      barChart: optionBar,
      mock_name: ['aa', 'dd', 'vv', 'cc', 'bb', 'aa', 'dd', 'vv', 'cc', 'bb'],
      nameSeries: ['Progress Order', 'Success Order'],
      opacityTemp: [1, 0.4, 0.4, 0.2, 0.2, 0.1, 0.1]
    }
  },
  watch: {},
  computed: {
    sumSuccessOrder () {
      const successOrder = this.getstatusLateNotLate
      return successOrder.late + successOrder.notLate
    },
    dateFormatter () {
      console.log(
        'dateFormatter',
        this.selectedDate,
        'return',
        dayjs(this.selectedDate).format('YYYY-MM-DD')
      )
      return dayjs(this.selectedDate).format('YYYY-MM-DD')
    },
    dateTimeFormatter () {
      let dateTime
      if (this.dateFormatter === dayjs().format('YYYY-MM-DD')) {
        dateTime = dayjs().subtract(8, 'hour').format('YYYY-MM-DDTHH:59:59[Z]')
      } else {
        dateTime = dayjs(this.selectedDate).format('YYYY-MM-DDT16:59:59[Z]')
      }
      console.log('dateTimeFormatter', this.selectedDate, 'return', dateTime)
      return dateTime
    },
    getStackChart () {
      const _temp = this.$store.getters['driverPerform/stackChart']
      // console.log('hour', _temp)
      return _temp
    },
    getCurrentStatHour () {
      const _temp = this.$store.getters['driverPerformV2/status']
      // console.log('hour', _temp)
      return _temp
    },
    getstatusLateNotLate () {
      const _temp = this.$store.getters['driverPerform/lateCount']
      // console.log('late', _temp)
      return _temp
    },
    getListDriverLateNotLate () {
      const _temp = this.$store.getters['driverPerform/listOfDriver']
      console.log('lateDriver', _temp)
      return _temp
    },
    activeDriverChart () {
      const _thisChart = { ...optionLine }
      _thisChart.legend = { data: this.nameSeries }
      const somedata = this.getCurrentStatHour
      console.log('hour', somedata)
      const chart = this.setHourDataSeries(somedata, _thisChart)
      return chart
    },
    chartLateOnTime () {
      const _thisChart = { ...optionPie }
      const somedata = this.getstatusLateNotLate
      console.log('late', somedata)
      const chart = this.setLateOnTimeSeries(somedata, _thisChart)
      return chart
    },
    stackChart () {
      const _thisChart = { ...optionLine }
      const _datafromStackChart = this.getStackChart
      console.log('stack', _datafromStackChart)
      _thisChart.legend = { data: _datafromStackChart.date }
      const chart = this.setStackChartSeries(_datafromStackChart, _thisChart)
      return chart
    },
    tableLate () {
      const _data = this.getListDriverLateNotLate.latesDriverDaily.items
      const listDriver = this.setTableLate(_data, this.getstatusLateNotLate)
      return listDriver
    },
    expressSLA () {
      return this.$store.getters['driverPerform/expressSLA']
    },
    expressSLAOrders () {
      return this.expressSLA?.Orders || []
    },
    chartExpressSLA () {
      const _thisChart = { ...optionPie2 }
      const somedata = this.expressSLA
      const chart = this.setExpressSLASeries(somedata, _thisChart)
      return chart
    },
    expressSLATableHeader () {
      return expressSLATableHeader
    },
    expressSLATable () {
      const clone = this.expressSLAOrders.map(order => {
        // const durationMS = Math.floor(order.SLA?.duration / 1000000)
        // const DeliveryTime = Math.floor(dayjs.duration(durationMS).asMinutes())
        // const slot = order.SLA?.slot
        const OrderCreationTime = order.OrderCreationTime === undefined ? null : dayjs(order.OrderCreationTime).format('HH:mm')
        const duration = Math.floor((order.SLA?.deliveryDuration / 1000000000) / 60)
        const branch = getBranchNameByCode(order.Brcode)
        const start = dayjs(order.SLA?.start).format('HH:mm')
        const end = dayjs(order.SLA?.end).format('HH:mm')
        // const duration = dayjs(order.SLA?.end).diff(order.SLA?.start, 'minute')

        const slotHourInt = parseInt(order.SlotTime)
        let slotTimeText
        if (slotHourInt + 1 < 10) {
          slotTimeText = `${order.SlotTime} - 0${slotHourInt + 1}:00`
        } else {
          slotTimeText = `${order.SlotTime} - ${slotHourInt + 1}:00`
        }

        let textLevel
        switch (order.SLA?.level) {
          case '1':
            textLevel = 'Excellent'
            break
          case '2':
            textLevel = 'Good'
            break
          case '3':
            textLevel = 'Fair'
            break
          case '4':
            textLevel = 'Poor'
            break
          case '5':
            textLevel = 'Bad'
            break
          default:
            break
        }

        // console.log('branch response', d.Brcode, branch)
        return {
          ...order,
          // DeliveryTime: DeliveryTime,
          Branch: branch?.name || '',
          Start: start,
          End: end,
          Duration: duration,
          OrderCreationTime,
          SlotTimeText: slotTimeText,
          Level: textLevel
        }
      })
      return clone.sort((a, b) => b.DeliveryTime - a.DeliveryTime)
    }
  },
  methods: {
    unloadedData () {
      console.log('TestTimeout Start')
      setTimeout(unload => {
        if (this.loading) {
          this.selectedDate = new Date()
          this.initOnStore()
          console.log('TestTimeout End')
          this.$buefy.notification.open({
            message: 'No Data On Your Seleted Date!\n return To Today',
            type: 'is-danger'
          })
        }
        console.log('TestTimeout Tricker')
      }, 5000)
    },
    async onupdateTest () {
      await this.$store.dispatch(
        'driverPerform/getListOfDriver',
        this.selectedDataRange
      )
      console.log('testttttTrigger', this.selectedDataRange)
    },
    setTableLate (_data, _successOrder) {
      const _new = []
      // let index = 1
      const _allOrder = _successOrder.late + _successOrder.notLate
      for (const i of _data) {
        const _delivered = i.late + i.notLate
        // const _onTimeRatioAll = (i.notLate / _allOrder) * 100
        const _onTimeRatioDriver = (i.notLate / _delivered) * 100
        _new.push({
          // no: index,
          driverName: i.driverName,
          delivered: _delivered,
          branch: i.origin,
          onTimeRatioDriver: _onTimeRatioDriver.toFixed(2)
        })
        // index++
      }
      _new.sort((a, b) => b.onTimeRatioDriver - a.onTimeRatioDriver)
      console.log('_allOrder', _allOrder)
      console.log('doTable', _new)
      return _new
    },
    setLateOnTimeSeries (_series, _chart) {
      _chart.series = [
        {
          type: 'pie',
          radius: ['30%', '60%'],
          label: {
            formatter: '{b|{b}} : {per|{d}%} \n {c|{c} orders} ',
            rich: {
              c: {
                color: '#86D4B5',
                lineHeight: 22,
                align: 'center',
                fontSize: 25
              },
              d: {
                borderColor: '#8C8D8E',
                width: '100%',
                borderWidth: 1,
                height: 0
              },
              b: {
                color: '#4C5058',
                fontSize: 18,
                fontWeight: 'bold',
                lineHeight: 33
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4
              }
            }
          },
          data: [
            { value: _series.notLate, name: 'On-time' },
            { value: _series.late, name: 'Late' }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
      return _chart
    },
    setExpressSLASeries (_series, _chart) {
      _chart.series = [
        {
          type: 'pie',
          radius: ['30%', '60%'],
          label: {
            formatter: '{b|{b}} : {per|{d}%} \n {c|{c} orders} ',
            rich: {
              c: {
                color: '#86D4B5',
                lineHeight: 22,
                align: 'center',
                fontSize: 20
              },
              d: {
                borderColor: '#8C8D8E',
                width: '100%',
                borderWidth: 1,
                height: 0
              },
              b: {
                color: '#4C5058',
                fontSize: 18,
                fontWeight: 'bold',
                lineHeight: 33
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4
              }
            }
          },
          data: [
            { value: _series?.Tier1, name: 'Deliver early' },
            { value: _series?.Tier2, name: '< 30 minute' },
            { value: _series?.Tier3, name: '30 - 60 minute' },
            { value: _series?.Tier4, name: '60 - 90 minute' },
            { value: _series?.Tier5, name: '> 90 minute' }
          ].filter(d => d.value > 0),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
      return _chart
    },
    getCurrent (_index, data) {
      const _data = []
      for (const i in data) {
        _data.push(data[i][_index])
      }
      return _data
    },
    setHourDataSeries (data, _chart) {
      const _data = []
      let index = 0
      for (const i of this.nameSeries) {
        _data.push({
          name: `${i}`,
          type: 'line',
          data: this.getCurrent(index, data)
          // data: [0,-1,1,1,100,1,2,3,4]
        })
        index++
      }
      _chart.series = _data
      return _chart
    },
    setStackChartSeries (data, _chart) {
      const _data = []
      for (const i in data) {
        _data.push({
          name: `${data[i].date}`,
          type: 'line',
          data: data[i].successOrder,
          lineStyle: {
            opacity: this.opacityTemp[i]
          },
          itemStyle: {
            opacity: this.opacityTemp[i]
          }
        })
      }
      _chart.series = _data
      return _chart
    },
    async onUpdateEveryHour () {
      const timmerCheck = dayjs().get('minute')
      console.log(timmerCheck)
      if (timmerCheck <= 10) {
        await this.$store.dispatch(
          'driverPerform/getLateCount',
          this.dateTimeFormatter
        )
        await this.$store.dispatch(
          'driverPerformV2/getStatus',
          this.dateFormatter
        )
        await this.$store.dispatch('driverPerform/getStackChart', {
          dateBetween: this.daylookback,
          initDate: this.dateFormatter
        })
        await this.$store.dispatch('driverPerform/getListOfDriver', {
          dataRange: this.selectedDataRange,
          _dateTime: this.dateTimeFormatter
        })
        this.updateTimeStamp = dayjs().format('YYYY-MM-DD HH:00:00')
      }
    },
    async initOnStore () {
      this.updateTimeStamp = dayjs().format('YYYY-MM-DD HH:00:00')
      this.loading = true
      await this.$store.dispatch(
        'driverPerform/getLateCount',
        this.dateTimeFormatter
      )
      await this.$store.dispatch(
        'driverPerformV2/getStatus',
        this.dateFormatter
      )
      await this.$store.dispatch('driverPerform/getStackChart', {
        dateBetween: this.daylookback,
        initDate: this.dateFormatter
      })
      await this.$store.dispatch('driverPerform/getListOfDriver', {
        dataRange: this.selectedDataRange,
        _dateTime: this.dateTimeFormatter
      })
      await this.$store.dispatch('driverPerform/getExpressSLA', this.dateFormatter)
      this.loading = false
    }
  },
  beforedestroy () {
    clearInterval(this.intervalidUpdate)
  }
}
</script>

<style scoped>
.is-excellent {
  background-color: #00a100 !important;
  color: #fff !important
}
.is-good {
  background-color: #48c78e !important;
  color: #fff !important
}
.is-fair {
  background-color: #e4c63c !important;
  color: #fff !important
}
.is-poor {
  background-color: #f75c84 !important;
  color: #fff !important
}
.is-bad {
  background-color: #c92750 !important;
  color: #fff !important
}
</style>
